import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = {
  type: "submit",
  form: "capex-account-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'

    import { CapexAccountEditorFormSubmitEventPayload } from '@Quest/Capex/Components/CapexAccountEditor'
    import type { CapexAccountEditorViewModel } from '@Quest/Capex/Components/CapexAccountEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CapexAccountEditor',
  props: {
    viewModel: {}
  },
  emits: ["form-submit"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const confirmButtonLabel = computed(() => vm.value.confirmButtonLabel)
    const modalTitle = computed(() => vm.value.modalTitle)

    // writable computeds (replace getter + setter pairs)

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    const description = computed<string | null>({
        get: () => vm.value.description,
        set: v => { vm.value.description = v }
    })

    const classification = computed<string | null>({
        get: () => vm.value.classification,
        set: v => { vm.value.classification = v }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        emit(
            'form-submit',
            new CapexAccountEditorFormSubmitEventPayload(
                vm.value.id,
                name.value,
                description.value,
                classification.value
            )
        )
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "capex-account-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      class: "form-control",
                      required: "",
                      maxlength: "100",
                      minlength: "2"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        description.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { for: "classification" }, "Depreciation:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "classification",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((classification).value = $event)),
                      class: "form-control"
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("option", { value: "OpEx" }, "OpEx", -1 /* CACHED */),
                      _createElementVNode("option", { value: "COGS" }, "COGS", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Other" }, "Other expenses", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, classification.value]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_12, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})